import { Alert, AlertTitle, Heading, LinkButton } from "@stacklet/ui";
import { graphql, useFragment } from "react-relay";

import { HelpDrawerTrigger } from "app/components/HelpDrawer/HelpDrawerTrigger";
import { paths } from "app/constants/paths";

import type { CreateNotificationRuleHeader_query$key } from "./__generated__/CreateNotificationRuleHeader_query.graphql";

interface Props {
  /** Fragment key for the root query */
  queryRef: CreateNotificationRuleHeader_query$key;
}

export function CreateNotificationRuleHeader({ queryRef }: Props) {
  const data = useFragment(
    graphql`
      fragment CreateNotificationRuleHeader_query on Query {
        jiraInstances {
          pageInfo {
            total
          }
        }
      }
    `,
    queryRef,
  );

  const hasJiraInstances = (data.jiraInstances?.pageInfo.total ?? 0) > 0;

  return (
    <>
      <div className="mb-6 flex items-center justify-between gap-2">
        <Heading level={2}>
          Create notification rule for new resource matches
        </Heading>
        <HelpDrawerTrigger />
      </div>
      {!hasJiraInstances ? (
        <Alert
          action={
            <LinkButton
              href={paths.settingsIntegrationsJira}
              variant="tertiary"
            >
              Go to Jira setup
            </LinkButton>
          }
          className="mb-6"
          severity="warning"
        >
          <AlertTitle severity="warning">Jira Integration Missing</AlertTitle>
          Jira must be set up in Stacklet before creating a notification rule.
        </Alert>
      ) : null}
    </>
  );
}
